import { TpDataContext } from '../../../data/interfaces';
import StaticText from '../other-elements/static-text/StaticText';
import Widget from '../widget/Widget';
import DashboardHorizontalLayout from '../layouters/dashboard-horizontal-layout';
import DashboardSection from '../layouters/dashboard-section';
import { DashboardTabberLayout } from '../layouters/dashboard-tabber';
import {
  DASHBOARDELEMIDS,
  TpActionButtonsDefinition,
  TpBitmapDefinition,
  TpChartDefinition,
  TpDashboardContext,
  TpDashboardElement,
  TpDashboardHorizontalLayoutDefinition,
  TpDashboardSectionDefinition,
  TpDashboardSequenceLayoutDefinition,
  TpDashboardTabberDefinition,
  TpDashboardVerticalLayoutDefinition,
  TpStaticTextDefinition,
} from './interfaces';
import DashboardVerticalLayout from '../layouters/dashboard-vertical-layout';
import BitMap from '../other-elements/bitmap/Bitmap';
import { DashboardElementErrorBoundary } from './DashboardElementErrorBoundary';
import DashboardActionButtons from '../actions/DashboardActionButtons';
import DashboardSequenceLayout from '../layouters/dashboard-sequence-layout';

export function renderDashboardElement(
  parentEl: TpDashboardElement | null,
  el: TpDashboardElement,
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
) {
  let element = <div>Empty element</div>;
  if (el.elemType == DASHBOARDELEMIDS.Widget) {
    element = (
      <Widget
        parentElemDef={parentEl}
        dataContext={dataContext}
        dashboardContext={dashboardContext}
        widgetDef={el as TpChartDefinition}
        handleOpenItem={dashboardContext.handleOpenItem}
      />
    );
  }

  if (el.elemType == DASHBOARDELEMIDS.StaticText) {
    element = (
      <StaticText
        parentElemDef={parentEl}
        dataContext={dataContext}
        elemDef={el as TpStaticTextDefinition}
        dashboardContext={dashboardContext}
      />
    );
  }

  if (el.elemType == DASHBOARDELEMIDS.Bitmap) {
    element = (
      <BitMap
        parentElemDef={parentEl}
        dataContext={dataContext}
        elemDef={el as TpBitmapDefinition}
        dashboardContext={dashboardContext}
      />
    );
  }

  if (el.elemType == DASHBOARDELEMIDS.HorizontalLayout) {
    element = (
      <DashboardHorizontalLayout
        parentElemDef={parentEl}
        dataContext={dataContext}
        elemDef={el as TpDashboardHorizontalLayoutDefinition}
        dashboardContext={dashboardContext}
      />
    );
  }

  if (el.elemType == DASHBOARDELEMIDS.VerticalLayout) {
    element = (
      <DashboardVerticalLayout
        parentElemDef={parentEl}
        dataContext={dataContext}
        elemDef={el as TpDashboardVerticalLayoutDefinition}
        dashboardContext={dashboardContext}
      />
    );
  }

  if (el.elemType == DASHBOARDELEMIDS.SequenceLayout) {
    element = (
      <DashboardSequenceLayout
        parentElemDef={parentEl}
        dataContext={dataContext}
        elemDef={el as TpDashboardSequenceLayoutDefinition}
        dashboardContext={dashboardContext}
      />
    );
  }

  if (el.elemType == DASHBOARDELEMIDS.Tabber) {
    element = (
      <DashboardTabberLayout
        parentElemDef={parentEl}
        dataContext={dataContext}
        elemDef={el as TpDashboardTabberDefinition}
        dashboardContext={dashboardContext}
      />
    );
  }

  if (el.elemType == DASHBOARDELEMIDS.Section) {
    element = (
      <DashboardSection
        dataContext={dataContext}
        sectionDef={el as TpDashboardSectionDefinition}
        dashboardContext={dashboardContext}
      />
    );
  }

  if (el.elemType == DASHBOARDELEMIDS.ActionButtons) {
    element = (
      <DashboardActionButtons
        parentElemDef={parentEl}
        dataContext={dataContext}
        elemDef={el as TpActionButtonsDefinition}
        dashboardContext={dashboardContext}
      />
    );
  }

  return (
    <DashboardElementErrorBoundary resetKeys={[el, dashboardContext.dataContextStatusIndex]}>
      {element}
    </DashboardElementErrorBoundary>
  );
}
